import { useState } from "react";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { CASE_STUDIES } from "../data/content";

const Block = ({ title, children }) => (
  <div className="case-block">
    <p className="case-label">{title}</p>
    {children}
  </div>
);

export const CaseStudies = () => {
  const [open, setOpen] = useState(-1);

  return (
    <section className="section section-alt" id="case-studies" data-testid="case-studies-section">
      <div className="wrap">
        <Reveal className="section-head">
          <span className="eyebrow"><span className="sq" /> Case Studies</span>
          <h2 data-testid="case-studies-heading">Depth over highlight reels.</h2>
          <p>Six projects, unpacked in full — the brief, the thinking, and what shipped. Click any project to expand.</p>
        </Reveal>

        <div className="case-list">
          {CASE_STUDIES.map((c, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={c.client} delay={i * 40}>
                <div className={`case-card ${isOpen ? "open" : ""}`} data-testid={`case-card-${c.client.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  <button
                    className="case-head"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`case-toggle-${c.client.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  >
                    <div className="left">
                      <span className="idx">{String(i + 1).padStart(2, "0")}</span>
                      <div>
                        <h3>{c.client}</h3>
                        <div className="tagline">{c.tagline}</div>
                      </div>
                    </div>
                    <span className="plus"><Plus size={22} strokeWidth={2.5} /></span>
                  </button>
                  <div className="case-body">
                    <div className="case-body-clip">
                      <div className="case-body-inner">
                        <div className="case-img">
                          <img src={c.img} alt={`${c.client} case study visual`} loading="lazy" width="1920" height="1080" />
                        </div>
                        <div>
                          <div className="case-meta">
                            <Block title="Context"><p>{c.context}</p></Block>
                            <Block title="Role"><p>{c.role}</p></Block>
                          </div>
                          <Block title="Problem"><p>{c.problem}</p></Block>
                          <Block title="Process">
                            <ul>{c.process.map((p) => <li key={p.slice(0, 40)}>{p}</li>)}</ul>
                          </Block>
                          <Block title="Solution"><p>{c.solution}</p></Block>
                          <div className="case-meta" style={{ marginTop: 18 }}>
                            <Block title="Outcome"><p>{c.outcome}</p></Block>
                            <Block title="Reflection"><p>{c.reflection}</p></Block>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
